import { StylesConfig } from 'react-select';
import styled from 'styled-components';
import theme from 'common/theme';

export const Wrapper = styled.div`
  // font-family: Arial, sans-serif;
  width: 100%;
`;

export const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  padding: 0px 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.41px;
  .label {
    color: ${(props) => props.theme.colors.textLightBlack};
  }
  .clear {
    cursor: pointer;

    text-align: left;
    color: ${(props) => props.theme.colors.primaryBlue5};
    font-weight: 600;
    line-height: 16px;
  }
`;

export const FilterContainer = styled.div<{ isError?: boolean; isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  background: ${(props) => (props.isDisabled ? props.theme.colors.disabledGrey : `white`)};
  border: ${(props) =>
    props.isError
      ? `1px solid ${props.theme.colors.darkRed3}`
      : `1px solid ${props.theme.colors.tableborder}`};
  border-radius: 5px;
  width: 100%;
  position: relative;
  flex: 1;

  .main-select {
    > div:nth-of-type(1) {
      div {
        color: ${(props) => props.theme.colors.lightGrey8};
        font-size: 14px;
      }
    }
  }

  .custom-render {
    width: 100%;
  }
  &:hover {
    ${({ isDisabled }) =>
      !isDisabled &&
      `
    box-shadow: 0px 0px 1px 2px ${`${theme.colors['mainColor']}26`};
    border: 1px solid ${theme.colors['mainColor']};
  `}
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${(props) => props.theme.colors.tableborder};
  margin: 0 10px;
`;

export const CustomDropdownIndicator = styled.div`
  padding-right: 10px;
  svg {
    width: 11px;
    color: ${(props) => props.theme.colors.lightGrey8};
  }
  &:hover {
    cursor: pointer;
  }
`;

export const customStyles: StylesConfig = {
  menu: (stylesProvided) => ({
    ...stylesProvided,
    overflow: 'auto',
    marginTop: 3,
    boxShadow: '0 14px 24px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    width: 'calc(105%)'
  }),
  menuList: (stylesProvided) => ({
    ...stylesProvided,
    paddingTop: 0,
    paddingBottom: 0
  }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      cursor: isDisabled ? 'not-allowed' : 'default',
      color: isDisabled
        ? `${theme.colors.border['main']} !important`
        : isSelected
        ? `${theme.colors['white']} !important`
        : `${theme.colors['main']} !important`
    };
  },
  valueContainer: (stylesProvided) => ({
    ...stylesProvided,
    gap: '4px'
  }),
  control: (stylesProvided) => ({
    ...stylesProvided,
    border: 'none',
    outline: 'none',
    width: '100%',
    // This line disable the blue border
    boxShadow: 'none'
  }),
  loadingIndicator: (style) => ({
    ...style,
    display: 'none'
  })
};
